// extracted by mini-css-extract-plugin
export default {"contactContainer":"contact_contactContainer__xFoNT","contactCard":"contact_contactCard__Htj5R","contactBtn":"contact_contactBtn__iB2Qj"};